import { SearchResult } from '#server/models';
import {
  ResultCard,
  ResultCardDescription,
  ResultCardHeader,
  ResultCardTitle,
  ResultCardLink,
  ResultCardTag,
  ResultCardContent,
  Badge,
  Divider,
  HighlightedText,
} from '@/components';
import { cn, formatDisplayDate } from '@/utils';

export interface PodcastResultCardProps {
  result: SearchResult;
}

export const PodcastResultCard = ({ result }: PodcastResultCardProps) => {
  const podcastDetails = result.podcastDetails!;

  return (
    <ResultCardLink to={podcastDetails.url} result={result}>
      <ResultCard className={cn((result.forYou ?? false) && 'border-highlight-border bg-highlight-bg')}>
        <ResultCardHeader>
          <ResultCardTag className="flex items-center">
            {(result.forYou ?? false) && <Badge className="mr-2 bg-ring text-white">For You</Badge>}
            <Badge variant={(result.forYou ?? false) ? 'forYou' : 'secondary'}>Podcast</Badge>
            {podcastDetails.length && (
              <div
                className="relative ml-3 cursor-pointer pl-4 text-xs font-semibold underline underline-offset-2 before:absolute before:left-0
                  before:top-1/2 before:h-1 before:w-1 before:-translate-y-1/2 before:rounded-full before:bg-gray-500 before:content-['']"
              >
                {podcastDetails.length}
              </div>
            )}
          </ResultCardTag>
          <ResultCardTitle>{podcastDetails.title}</ResultCardTitle>
          <ResultCardDescription>
            <HighlightedText text={podcastDetails.description} />
          </ResultCardDescription>
        </ResultCardHeader>
        {podcastDetails.publishedDate && (
          <ResultCardContent>
            <Divider className={cn((result.forYou ?? false) && 'bg-highlight-divider')} />
            <div
              className={cn(
                'mt-4 flex flex-col gap-2 rounded-lg bg-primary-website-background-colour px-5 py-3 text-sm md:flex-row md:gap-16',
                (result.forYou ?? false) && 'bg-white',
              )}
            >
              <div className="flex md:gap-8">
                <div className="w-28 font-semibold md:w-auto">Published</div>
                <div className="text-secondary-grey-01">{formatDisplayDate(podcastDetails.publishedDate)}</div>
              </div>
            </div>
          </ResultCardContent>
        )}
      </ResultCard>
    </ResultCardLink>
  );
};
